import { Navigate, Route, Routes } from 'react-router';

import PrivateRoute from './PrivateRoute/PrivateRoute';
import CreateAccount from '../pages/Auth/CreateAccount/CreateAccount';
import ForgotPassword from '../pages/Auth/ForgotPassword/ForgotPassword';
import Login from '../pages/Auth/Login/Login';
import Clients from '../pages/Clients/Clients';
import ClientProfile from '../pages/Clients/sections/ClientProfile/ClientProfile';
import Prospects from '../pages/Prospects/Prospects';
import ProspectProfile from '../pages/Prospects/sections/ProspectProfile/ProspectProfile';
import CreateQuote from '../pages/Quotes/CreateQuote/CreateQuote';
import {
  CLIENT_PROFILE_ROUTE,
  CLIENTS_ROUTE,
  LOGIN_ROUTE,
  PROSPECT_PROFILE_ROUTE,
  PROSPECTS_ROUTE,
  QUOTE_CREATE_ROUTE,
  QUOTE_EDIT_ROUTE,
  RESET_PASSWORD_ROUTE,
  SIGN_UP_ROUTE
} from '../shared/constants/auth';
import AppLayout from '../shared/layouts/AppLayout/AppLayout';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        }
      >
        <Route path={PROSPECTS_ROUTE} element={<Prospects />} />
        <Route path={CLIENTS_ROUTE} element={<Clients />} />
        <Route path={CLIENT_PROFILE_ROUTE} element={<ClientProfile />} />
        <Route path={PROSPECT_PROFILE_ROUTE} element={<ProspectProfile />} />
        <Route path={QUOTE_CREATE_ROUTE} element={<CreateQuote />} />
        <Route path={QUOTE_EDIT_ROUTE} element={<CreateQuote />} />
      </Route>

      <Route path={LOGIN_ROUTE} element={<Login />} />
      <Route path={SIGN_UP_ROUTE} element={<CreateAccount />} />
      <Route path={RESET_PASSWORD_ROUTE} element={<ForgotPassword />} />

      <Route path="*" element={<Navigate to={PROSPECTS_ROUTE} replace />} />
    </Routes>
  );
};

export default AppRoutes;
